import { Simplify, Support, Tools, Ecosystem} from "../components/pages/mainPage";

export function MainPage() {
    return(
        <>
            <Simplify />
            {/* <Industries /> */}
            <Tools />
            {/* <WhoWeAre /> */}
            {/* <Blog /> */}
            {/* <Support /> */}
            {/* <Partners />             */}
            {/* <GetInTouch /> */}
            <Ecosystem />
        </>
    )
}